import React from 'react';
import { Shield, Users, Calendar, Video, Book, Bell, Settings, Home, BarChart2, Database, FileText, MessageSquare, BookOpenCheck, HelpingHand, FileText as FileTextIcon } from 'lucide-react';
import { useNavigate, Link, useLocation } from 'react-router-dom';

interface AdminLayoutProps {
  children: React.ReactNode;
  title: string;
}

const menuItems = [
  { icon: Shield, label: 'Dashboard', path: '/admin' },
  { icon: Users, label: 'Usuários', path: '/admin/users' },
  { icon: Calendar, label: 'Eventos', path: '/admin/events' },
  { icon: Video, label: 'Transmissões', path: '/admin/live' },
  { icon: Book, label: 'Mensagens', path: '/admin/messages' },
  { icon: MessageSquare, label: 'Pedidos de Oração', path: '/admin/prayers' },
  { icon: HelpingHand, label: 'Orientação Espiritual', path: '/admin/spiritual-guidance' },
  { icon: Bell, label: 'Notificações', path: '/admin/notifications' },
  { icon: BookOpenCheck, label: 'Dicas Cristãs', path: '/admin/christian-tips' },
  { icon: MessageSquare, label: 'Testemunhos', path: '/admin/testimonials' },
  { icon: FileTextIcon, label: 'Documentos Legais', path: '/admin/settings' },
  { icon: Database, label: 'Backup', path: '/admin/backup' },
  { icon: FileText, label: 'Logs', path: '/admin/logs' },
  { icon: Settings, label: 'Configurações', path: '/admin/settings' },
];

export default function AdminLayout({ children, title }: AdminLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 bg-white border-r border-gray-200 min-h-screen">
          <div className="p-6">
            <div className="flex items-center gap-3 mb-8">
              <Shield className="h-8 w-8 text-brand-teal" />
              <span className="font-semibold text-gray-900">Administração</span>
            </div>

            <nav className="space-y-1">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    location.pathname === item.path
                      ? 'bg-brand-light text-brand-teal'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  <item.icon className="h-5 w-5" />
                  <span>{item.label}</span>
                </Link>
              ))}
            </nav>
          </div>
        </aside>

        {/* Main Content */}
        <div className="flex-1">
          {/* Header */}
          <header className="bg-white border-b border-gray-200 px-8 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Shield className="h-8 w-8 text-brand-teal" />
                <h1 className="text-2xl font-bold text-brand-teal">{title}</h1>
              </div>
              <button
                onClick={() => navigate('/')}
                className="flex items-center gap-2 px-4 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors"
              >
                <Home className="h-4 w-4" />
                <span>Voltar para o Site</span>
              </button>
            </div>
          </header>

          {/* Content */}
          <main className="p-8">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}